import React from "react";
import { AxiosResponse } from "axios";
import DataGrid, { Paging, Column, Editing, Scrolling } from "devextreme-react/data-grid";
import { LoadPanel } from "devextreme-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import FileService from "../../../services/FileService";
import MatrixGridService, { BulkVenueRowItem } from "../../../services/MatrixService";
import notify from "devextreme/ui/notify";
import MatchingBulkUpdateGrid from "./MatchingBulkUpdateGrid";
import lookupService from "../../../services/LookupService";

export const APIFLOW = {
    invites: "invites",
    users: "users",
    create: "create",
};
//props
interface BulkVenueUpdateProps {}
interface venueType {
    id: string;
    value: string;
    parentMappingId: null | string;
}
// State
interface BulkVenueUpdateState {
    pastedGridDataSource: BulkVenueRowItem[];
    matchingGridDataSource: any[];
    findMatchesClicked: boolean;
    showFindMatches: boolean;
    showSendInvites: boolean;
    showMatchingGrid: boolean;
    showLoadPanel: boolean;
    selectedMatchingData: any[];
    reloadMatchingGrid: boolean;
    userResponseData: any[];
    venueType: venueType[];
    errorMsg: any[];
}

class BulkVenueUpdate extends React.Component<BulkVenueUpdateProps> {
    //Initialize the component's state.
    state: BulkVenueUpdateState;
    dataGridRef: any;
    fileService: FileService;
    matrixGridService: MatrixGridService;
    lookupService: lookupService;
    constructor(props: BulkVenueUpdateProps) {
        super(props);
        // Initialize state and services/utils
        this.dataGridRef = null;
        this.fileService = new FileService();
        this.matrixGridService = new MatrixGridService();
        this.lookupService = new lookupService();
        this.state = {
            pastedGridDataSource: [],
            showLoadPanel: false,
            showFindMatches: false,
            showMatchingGrid: false,
            showSendInvites: false,
            matchingGridDataSource: [],
            findMatchesClicked: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            userResponseData: [],
            venueType: [],
            errorMsg: [],
        };
    }

    componentDidMount() {
        let obj = this.getDefaultObject(0);
        let stateArr = this.state.pastedGridDataSource;
        stateArr.push(obj);
        this.setState({ pastedGridDataSource: stateArr });
        this.getVenueType();
    }

    getVenueType = () => {
        this.lookupService
            .getVenueTypeDetails()
            .then(this.handleSuccessServiceTypeLookupSuccess)
            .catch(this.handleError);
    };
    handleSuccessServiceTypeLookupSuccess = (response: AxiosResponse<any>) => {
        if (response && response.data.data) {
            this.setState({
                venueType: response.data.data,
            });
        }
    };
    handleError = (error: AxiosResponse<any>) => {
        var respMessage: string = "Payment request form load failed with response: " + JSON.stringify(error);

        if (!this.matrixGridService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };
    //When a component is updated this lifecycle method is called, and a change in props here would trigger this.
    componentDidUpdate(prevProps: BulkVenueUpdateProps, prevState: BulkVenueUpdateState) {}

    isSendInvitesDisabled = () => {
        let disabled = true;
        let inviteUsers = this.state.selectedMatchingData.filter((a) => a.canInviteUser);
        if (this.state.matchingGridDataSource?.length > 0 && inviteUsers?.length > 0) {
            disabled = false;
        }
        return disabled;
    };

    isMissingUsersDisabled = () => {
        let disabled = true;
        let missingUser = this.state.selectedMatchingData.filter((a) => a.canCRUDUser);
        if (missingUser && missingUser?.length > 0) {
            disabled = false;
        }
        return disabled;
    };

    isCreateUserDisabled = () => {
        let disabled = true;
        let inviteUsers = this.state.selectedMatchingData.filter(
            (a) => a.found === "Venue Not Found" || a.found === "Duplicate Venue"
        );
        if (inviteUsers?.length > 0 || this.state.selectedMatchingData.length == 0) {
            disabled = true;
        } else {
            disabled = false;
        }
        return disabled;
    };
    findVenueTypeId = (venueType: string) => {
        if (venueType === "") {
            return "";
        } else {
            let venueTypeId = this.state.venueType.find((item) => item.value.toLowerCase() === venueType.toLowerCase());
            if (venueTypeId) {
                return venueTypeId.id;
            } else {
                return "";
            }
        }
    };
    checkId = () => {
        let invalidIdCount = 0;
        let invalidBusinessEntityIdCount = 0;
        let invalidVenueTypeIdCount = 0;
        let errormsg = [];
        let invalidIsActivePresent = 0;
        let invalidIsOnboardPresent = 0;
        let invalidOnboarded = 0;
        let invalidActive = 0;
        let updatedPastedGridDataSource = this.state.pastedGridDataSource.map((element: any) => {
            const isIdValid = element.id === "" || /^\d+$/.test(element.id);
            const isBusinessIdValid = element.businessEntityId === "" || /^\d+$/.test(element.businessEntityId);
            const isOnboardPresent = element.onboarded === "";
            const isActivePresent = element.active === "";
            const inInvalidOnboarded =
                element.onboarded !== "" &&
                element.onboarded.toLowerCase() !== "yes" &&
                element.onboarded.toLowerCase() !== "no";

            const inInvalidActive =
                element.active !== "" &&
                element.active.toLowerCase() !== "yes" &&
                element.active.toLowerCase() !== "no";
            let isVenueTypeInvalid = false
            let venueTypeId = this.findVenueTypeId(element.venueTypeId);
            if (element.venueTypeId !== "" && venueTypeId === "") {
                isVenueTypeInvalid=true
            }
            const errorMessages = [];

            if (!isIdValid) {
                invalidIdCount += 1;
                errorMessages.push({
                    columnName: "ID",
                    errorType: "Error",
                    errorMessage: "Invalid ID format. Only digits allowed.",
                });
            }

            if (!isBusinessIdValid) {
                invalidBusinessEntityIdCount += 1;
                errorMessages.push({
                    columnName: "Business Entity ID",
                    errorType: "Error",
                    errorMessage: "Invalid Business Entity ID format. Only digits allowed.",
                });
            }
            if (isVenueTypeInvalid) {
                invalidVenueTypeIdCount += 1;
                errorMessages.push({
                    columnName: "Venue Type",
                    errorType: "Error",
                    errorMessage: "Invalid Venue Type",
                });
            }
            if (isOnboardPresent) {
                invalidIsOnboardPresent += 1;
                errorMessages.push({
                    columnName: "Onboarded",
                    errorType: "Error",
                    errorMessage: "Onboarded value is required",
                });
            }
            if (isActivePresent) {
                invalidIsActivePresent += 1;
                errorMessages.push({
                    columnName: "Active",
                    errorType: "Error",
                    errorMessage: "Active value is required",
                });
            }
            if (inInvalidOnboarded) {
                invalidOnboarded += 1;
                errorMessages.push({
                    columnName: "Onboarded",
                    errorType: "Error",
                    errorMessage: "Onboarded should be either Yes or No",
                });
            }
            if (inInvalidActive) {
                invalidActive += 1;
                errorMessages.push({
                    columnName: "Active",
                    errorType: "Error",
                    errorMessage: "Active should be either Yes or No",
                });
            }
            return {
                ...element,
                errorMessage: errorMessages,
            };
        });
        if (invalidIdCount > 0) {
            errormsg.push({
                columnName: "ID",
                errorType: "Error",
                errorMessage: "Invalid ID format. Only digits allowed.",
            });
        }
        if (invalidBusinessEntityIdCount > 0) {
            errormsg.push({
                columnName: "Business Entity ID",
                errorType: "Error",
                errorMessage: "Invalid Business Entity ID format. Only digits allowed.",
            });
        }
        if (invalidVenueTypeIdCount > 0) {
            errormsg.push({
                columnName: "Venue Type",
                errorType: "Error",
                errorMessage: "Invalid Venue Type",
            });
        }
        if (invalidIsOnboardPresent > 0) {
            errormsg.push({
                columnName: "Onboarded",
                errorType: "Error",
                errorMessage: "Onboarded value is required",
            });
        }
        if (invalidIsActivePresent > 0) {
            errormsg.push({
                columnName: "Active",
                errorType: "Error",
                errorMessage: "Active value is required",
            });
        }
        if (invalidOnboarded > 0) {
            errormsg.push({
                columnName: "Onboarded",
                errorType: "Error",
                errorMessage: "Onboarded should be either Yes or No",
            });
        }
        if (invalidActive > 0) {
            errormsg.push({
                columnName: "Active",
                errorType: "Error",
                errorMessage: "Active should be either Yes or No",
            });
        }
        if (
            invalidIdCount === 0 &&
            invalidBusinessEntityIdCount === 0 &&
            invalidVenueTypeIdCount === 0 &&
            invalidIsActivePresent === 0 &&
            invalidIsOnboardPresent === 0 &&
            invalidOnboarded === 0 &&
            invalidActive === 0
        ) {
            this.setState({ errorMsg: [] });
            return true;
        } else {
            this.setState({ errorMsg: errormsg, pastedGridDataSource: updatedPastedGridDataSource });
            return false;
        }
    };

    onClickCheckForDuplicates = () => {
        let verifyId = this.checkId();
        if (verifyId) {
            this.setState({ findMatchesClicked: true, showMatchingGrid: true });
        }
    };

    displayErrorMessage = (cellInfo: any) => {
        let errMsgArr = cellInfo?.data?.data?.errorMessage || [];
        return (
            <span>
                <ul className="mb-0">
                    {errMsgArr && errMsgArr.length > 0
                        ? errMsgArr.map((item: any, uniqueKey: number) => {
                              return (
                                  <li key={uniqueKey}>
                                      <b className={item.ErrorType == "Warning" ? `text-warning` : `text-danger`}>
                                          {item.columnName} : {item.errorMessage}
                                      </b>
                                      {/* : "{item.errorType} - {item.errorMessage}" */}
                                  </li>
                              );
                          })
                        : null}
                </ul>
            </span>
        );
    };

    getDefaultObject = (index: any) => {
        let obj: BulkVenueRowItem = {
            id: "click here to paste from excel",
            businessEntity: "",
            businessEntityId: "",
            houseNumber: "",
            venueName: "",
            address: "",
            city: "",
            county: "",
            postCode: "",
            phone: "",
            email: "",
            brand: "",
            division: "",
            website: "",
            venueNameWOLocation: "",
            venueTypeId: "",
            onboarded: "",
            active: "",
            errorMessage: [],
        };
        return obj;
    };

    checkForRowsToAdd = (currentRowIndex: any, pastedRows: any) => {
        let patedsRowLength = pastedRows.length;
        let gridRows = this.state.pastedGridDataSource;
        let availableRows = gridRows.slice(currentRowIndex, gridRows.length);
        if (availableRows?.length <= patedsRowLength) {
            let rowsToadd = patedsRowLength - availableRows.length;
            // for (let i = 0; i <= rowsToadd; i++) {
            for (let i = 0; i < rowsToadd; i++) {
                let index = gridRows.length;
                let obj = this.getDefaultObject(index);
                gridRows.push(obj);
            }
        }
        return gridRows;
    };

    handlePaste = (editEvent: any, e: any, currentRow: any, currentDataField: any) => {
        let pastedData = e.clipboardData.getData("Text");
        let pastedRows = pastedData.split("\n")?.filter((a: any) => a !== "");
        let rowIndex = currentRow.dataIndex;
        //rowIndex = currentRow.data.uuid; //if added pagination
        let stateObj = this.checkForRowsToAdd(rowIndex, pastedRows);
        let allRows = stateObj;
        pastedRows.forEach((element: any, rindex: any) => {
            let roToUpdate = rowIndex + rindex;
            let currPastedRow = pastedRows[rindex];
            // let splittedCells = pastedRows[rindex].split('\t');
            let splittedCells = currPastedRow.replace(/(\r)/gm, "").split("\t");
            let currRow = allRows[roToUpdate];
            //const dataFields = Object.keys(currRow).slice(0, 5);
            const dataFields = Object.keys(currRow);
            //check for duplicate
            for (let fieldID = 0; fieldID < dataFields.length; fieldID++) {
                if (dataFields[fieldID] === currentDataField) {
                    for (let i = 0; i < dataFields.length - fieldID && i < splittedCells.length; i++) {
                        let key = dataFields[fieldID + i];
                        let val = splittedCells[i];
                        this.dataGridRef?.instance()?.cellValue(roToUpdate, key, val);
                        if (key == "id") {
                            currRow.id = val;
                        } else if (key == "businessEntity") {
                            currRow.businessEntity = val;
                        } else if (key == "businessEntityId") {
                            currRow.businessEntityId = val;
                        } else if (key == "houseNumber") {
                            currRow.houseNumber = val;
                        } else if (key == "venueName") {
                            currRow.venueName = val;
                        } else if (key == "address") {
                            currRow.address = val;
                        } else if (key == "city") {
                            currRow.city = val;
                        } else if (key == "county") {
                            currRow.county = val;
                        } else if (key == "postCode") {
                            currRow.postCode = val;
                        } else if (key == "phone") {
                            currRow.phone = val;
                        } else if (key == "email") {
                            currRow.email = val;
                        } else if (key == "brand") {
                            currRow.brand = val;
                        } else if (key == "division") {
                            currRow.division = val;
                        } else if (key == "website") {
                            currRow.website = val;
                        } else if (key == "venueNameWOLocation") {
                            currRow.venueNameWOLocation = val;
                        } else if (key == "venueTypeId") {
                            currRow.venueTypeId = val;
                        } else if (key == "onboarded") {
                            currRow.onboarded = val;
                        } else if (key == "active") {
                            currRow.active = val;
                        }
                        if (currRow.id == "click here to paste from excel") {
                            currRow.id = "";
                        }
                        currRow.errorMessage = [];
                        //}
                    }
                }
            }
        });
        this.dataGridRef?.instance()?.saveEditData();

        let show = false;
        if (stateObj && stateObj.some((a) => a.email?.trim())) {
            show = true;
        }
        console.log("stateObj", stateObj);
        this.setState({ pastedGridDataSource: stateObj, showFindMatches: show });
        editEvent.cancel = true;
    };

    onCellClick = (clickEvent: any) => {
        const currentDataField = clickEvent.column.dataField;
        const currentRow = clickEvent.row;

        clickEvent.cellElement.onpaste = (pasteEvent: any) => {
            this.handlePaste(clickEvent, pasteEvent, currentRow, currentDataField);
        };
    };

    onRefreshClick = () => {
        let obj = this.getDefaultObject(0);
        let stateArr = [];
        stateArr.push(obj);

        this.setState({
            pastedGridDataSource: stateArr,
            showFindMatches: false,
            findMatchesClicked: false,
            showSendInvites: false,
            matchingGridDataSource: [],
            showMatchingGrid: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            userResponseData: [],
            errorMsg: "",
        });
    };

    updateFoundRecords = () => {
        this.setState({
            showSendInvites: true,
            findMatchesClicked: false,
            selectedMatchingData: [],
            reloadMatchingGrid: false,
            showLoadPanel: false,
        });
    };

    setSelectedRows = (rows: any) => {
        this.setState({ selectedMatchingData: rows });
    };

    handleSuccess = (response: AxiosResponse<any>, flow: string, requestArr: any) => {
        this.setState({
            showLoadPanel: false,
        });
        if (flow) {
            notify({ message: "Operations Completed!", width: 300, shading: true, position: "center" }, "success", 600);
        }
    };

    handleFailure = (error: any) => {
        if (error.response.status === 400) {
            let newdata: any = this.state.selectedMatchingData.map((parentItem, index) => {
                return {
                    ...parentItem,
                    validationErrors: error.response.data.data[index].validationErrors,
                };
            });
            let updatedPastedGridDataSource: any = this.state.pastedGridDataSource.map((parentItem: any) => {
                const matchingChild = newdata.find(
                    (childItem: any) =>
                        childItem.businessEntityId === parentItem.businessEntityId &&
                        childItem.venueName === parentItem.venueName &&
                        childItem.id === parentItem.id &&
                        childItem.businessEntity?.shortName === parentItem.businessEntity &&
                        childItem.houseNumber === parentItem.houseNumber &&
                        childItem.venueName === parentItem.venueName &&
                        childItem.address === parentItem.address &&
                        childItem.city === parentItem.city &&
                        childItem.county === parentItem.county &&
                        childItem.postCode === parentItem.postCode &&
                        childItem.phone === parentItem.phone &&
                        childItem.email === parentItem.email &&
                        childItem.brand === parentItem.brand &&
                        childItem.division === parentItem.division &&
                        childItem.website === parentItem.website &&
                        childItem.venueNameWOLocation === parentItem.venueNameWOLocation &&
                        childItem.venueType.value === parentItem.venueTypeId
                );
                return {
                    ...parentItem,
                    errorMessage: matchingChild?.validationErrors ?? parentItem.errorMessage ?? [],
                };
            });
            this.setState(
                {
                    showLoadPanel: false,
                    pastedGridDataSource: updatedPastedGridDataSource,
                },
                () => {
                    notify(
                        { message: "Sorry! The operation could not be completed.", width: 300, shading: true },
                        "error",
                        600
                    );
                }
            );
            var respMessage: string = "Bulk operations failed with response: " + JSON.stringify(error);

            if (!this.matrixGridService.traceAsErrorToAppInsights(respMessage)) {
                // AppInsights is not available
                console.error(respMessage);
            }
        } else {
            this.setState(
                {
                    showLoadPanel: false,
                },
                () => {
                    notify(
                        { message: "Sorry! The operation could not be completed.", width: 300, shading: true },
                        "error",
                        600
                    );
                }
            );
            var respMessage: string = "Bulk operations failed with response: " + JSON.stringify(error);

            if (!this.matrixGridService.traceAsErrorToAppInsights(respMessage)) {
                // AppInsights is not available
                console.error(respMessage);
            }
        }
    };

    onClickCreateBulkVenues = () => {
        let payload: any = [];
        payload = this.state.selectedMatchingData;
        this.setState({ showLoadPanel: true });
        this.matrixGridService
            .addEditVenue(payload)
            .then((res: any) => this.handleSuccess(res, APIFLOW.create, payload))
            .catch(this.handleFailure);
    };

    renderMatchingGrid = () => {
        let header = "Venues Found & New Venues";
        if (this.state.showMatchingGrid) {
            return (
                <>
                    <h2 className="page-title__black-table">{header}</h2>
                    <MatchingBulkUpdateGrid
                        updateFoundRecords={this.updateFoundRecords}
                        setSelectedRows={this.setSelectedRows}
                        findMatchesClicked={this.state.findMatchesClicked}
                        pastedDetails={this.state.pastedGridDataSource}
                        reloadMatchingGrid={this.state.reloadMatchingGrid}
                        userResponseData={this.state.userResponseData}
                        venueType={this.state.venueType}
                    ></MatchingBulkUpdateGrid>
                </>
            );
        }
    };

    onDownloadClick = () => {
        let downloadId = "bulkcreatevenues";
        if (downloadId) {
            this.setState({
                showLoadPanel: true,
            });
            this.fileService
                .downloadTemplate(downloadId)
                .then(this.handleDownloadSuccess)
                .catch(this.handleDownloadError);
        }
    };

    handleDownloadSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            showLoadPanel: false,
        });
        saveAs(response.data, "template_bulk_venue.xlsx");
    };

    handleDownloadError = (error: any) => {
        this.setState({
            showLoadPanel: false,
        });
        var respMessage: string = "Download template failed with response: " + JSON.stringify(error);

        if (!this.fileService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };

    render() {
        let header = "Bulk Venue Update";
        return (
            <>
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.showLoadPanel} />
                <>
                    <div style={{ display: "flex" }}>
                        <h2 className="page-title__black-table">
                            {header}
                            <button
                                className="status-flow__refresh-button btn icon-btn"
                                aria-label="Refresh the current manage pay dates"
                                onClick={this.onRefreshClick}
                            >
                                <FontAwesomeIcon icon={faSync} title="reset grid data" />
                            </button>
                        </h2>
                        <h5 style={{ padding: "15px 0px 0px 15px" }}>
                            <Link
                                onClick={(e) => {
                                    this.onDownloadClick();
                                }}
                                className="approval-query-column"
                                to="#"
                            >
                                Download Template
                            </Link>
                        </h5>
                    </div>
                    <DataGrid
                        dataSource={this.state.pastedGridDataSource}
                        showBorders={false}
                        showColumnLines={false}
                        allowColumnReordering={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        noDataText={"No data found for the filters applied"}
                        onCellClick={this.onCellClick}
                        ref={(ref) => {
                            this.dataGridRef = ref;
                        }}
                    >
                        <Paging defaultPageSize={20} enabled={true} />
                        <Scrolling mode="infinite" />
                        <Editing mode="cell" allowUpdating={false} startEditAction="click" allowDeleting={false} />
                        <Column dataField="id" caption="ID" />
                        <Column dataField="businessEntity" caption="CLIENT" />
                        <Column dataField="businessEntityId" caption="CLIENT ID" />
                        <Column dataField="houseNumber" caption="HOUSE NUMBER" />
                        <Column dataField="venueName" caption="VENUE NAME" />
                        <Column dataField="address" caption="ADDRESS" />
                        <Column dataField="city" caption="TOWN/CITY" />
                        <Column dataField="county" caption="COUNTY" />
                        <Column dataField="postCode" caption="POSTCODE" />
                        <Column dataField="phone" caption="PHONE" />
                        <Column dataField="email" caption="EMAIL" />
                        <Column dataField="brand" caption="BRAND" />
                        <Column dataField="division" caption="DIVISION" />
                        <Column dataField="website" caption="WEBSITE" />
                        <Column dataField="venueNameWOLocation" caption="VENUE NAME WO LOCATION" />
                        <Column dataField="venueTypeId" caption="VENUE TYPE" />
                        <Column dataField="onboarded" caption="ONBOARDED" />
                        <Column dataField="active" caption="ACTIVE" />
                        <Column
                            dataField="errorMessage"
                            caption="WARNINGS / ERRORS"
                            cellComponent={(cellInfo: any) => {
                                return this.displayErrorMessage(cellInfo);
                            }}
                        />
                    </DataGrid>
                    <span>
                        <ul className="mb-0">
                            {this.state.errorMsg && this.state.errorMsg.length > 0
                                ? this.state.errorMsg.map((item: any, uniqueKey: number) => {
                                      return (
                                          <li key={uniqueKey}>
                                              <b
                                                  className={
                                                      item.ErrorType == "Warning" ? `text-warning` : `text-danger`
                                                  }
                                              >
                                                  {item.columnName} : {item.errorMessage}
                                              </b>
                                              {/* : "{item.errorType} - {item.errorMessage}" */}
                                          </li>
                                      );
                                  })
                                : null}
                        </ul>
                    </span>
                    <div className="col-12 col-lg-2 mb-3 mr-auto">
                        <button
                            className="btn btn-primary btn--large mt-3"
                            type="button"
                            disabled={!this.state.showFindMatches}
                            onClick={(e: React.MouseEvent) => {
                                //e.preventDefault();
                                this.onClickCheckForDuplicates();
                            }}
                        >
                            FIND VENUES
                        </button>
                    </div>
                </>
                {this.renderMatchingGrid()}
                <div className="row mt-3" hidden={!this.state.showSendInvites}>
                    <div className="col-12 col-lg-2 mb-3">
                        <button
                            className="btn btn-primary btn--large mt-3"
                            type="button"
                            disabled={this.isCreateUserDisabled()}
                            onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                this.onClickCreateBulkVenues();
                            }}
                        >
                            APPLY UPDATES
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default BulkVenueUpdate;
